/* @flow */

import { errorColor } from '@e180/ui/lib/token/color';
import { mediumGrey } from '@e180/ui/lib/token/palette';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    color: mediumGrey,

    fontStyle: 'italic',
    lineHeight: 19 / baseFontSize,
    textAlign: 'center',
    WebkitFontSmoothing: 'antialiased',
  },
  'root-withError': {
    color: errorColor,
  },
  'root-left': {
    textAlign: 'left',
  },
};
